const setFloorplanList = (state, payload) => {
  state.list = payload;
};

const setFloorList = (state, payload) => {
  state.floorList = payload;
};

const setFilters = (state, payload) => {
  state.filters = payload;
};

const toggleListDisplayType = (state) => {
  if (state.listDisplayType === 'grid') state.listDisplayType = 'table';
  else state.listDisplayType = 'grid';
};

const setShowFavourites = (state, payload) => {
  state.showFavourites = payload;
};

const setFloorplanFavourited = (state, floorplanId) => {
  const toggledFloorplan = state.list.find(floorplan => floorplan.id === floorplanId);
  toggledFloorplan.favourited = !toggledFloorplan.favourited;
};

const setFavouritedIdList = (state, payload) => {
  if (payload) {
    state.favouritedIdList = payload;
  }
};

const sortFloorplanListAsc = (state) => {
  state.list.sort((a, b) => a.interior - b.interior);
};

const sortFloorplanListDsc = (state) => {
  state.list.sort((a, b) => b.interior - a.interior);
};

const updateUnitsStatus = (state, payload) => {
  payload.units.forEach((unit) => {
    state.list.forEach((floorplan) => {
      floorplan.stacks.forEach((stack) => {
        stack.suites.forEach((suite) => {
          if (suite.id && suite.id.toString() === unit.toString()) {
            suite.status = payload.status;
          }
        });
      });
    });
  });
};

const setSelectedUnitName = (state, unitName) => {
  state.selectedUnitName = unitName;
};

export default {
  setFloorplanList,
  setFloorList,
  setFilters,
  toggleListDisplayType,
  setShowFavourites,
  setFloorplanFavourited,
  setFavouritedIdList,
  sortFloorplanListAsc,
  sortFloorplanListDsc,
  updateUnitsStatus,
  setSelectedUnitName
};



// WEBPACK FOOTER //
// ./src/store/modules/floorplans/mutations.js